/**
 * subheaderDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

subheaderDirective.$inject = [];

export function subheaderDirective() {
    return {
        restrict: 'E',
        transclude: {
            actions: '?actions',
        },
        template: `
            <!--<md-icon class="app-subheader-icon" md-svg-icon="{{ icon }}" ng-if="icon">{{ icon }}</md-icon>-->
            <span class="app-subheader-content" ng-transclude></span>
            
            <div class="float-right" ng-transclude="actions"></div>
        `,
        scope: {
            icon: '@',
        },
    };
}
